import { BillingPaymentMethodKind } from "@/shared/client-billing-payment-method/constants/billing-payment-method";

export enum CombinedProcedureCodesValueSet {
  BASE_URL = "http://quiltedhealth.com/fhir/ValueSet/combined-procedure-codes",
}

/**
 * How a charge was priced. Carried by each `ChargeItem` in the `service-payer` extension and copied
 * onto the Invoice generated from them, so the statement records the payment method without
 * re-deriving it from coverage. Every charge on one statement must agree on it.
 */
export const PaymentMethod = {
  Insurance: BillingPaymentMethodKind.Insurance,
  SelfPay: BillingPaymentMethodKind.SelfPay,
} as const;
export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod];

/** Statuses that mean "this statement is void". Both are terminal, and both keep their number. */
export const VOID_INVOICE_STATUSES: ReadonlySet<string> = new Set([
  "cancelled",
  "entered-in-error",
]);
